import { render, staticRenderFns } from "./SkillsWorkflowSelector.vue?vue&type=template&id=047a22a4&scoped=true&"
import script from "./SkillsWorkflowSelector.vue?vue&type=script&lang=js&"
export * from "./SkillsWorkflowSelector.vue?vue&type=script&lang=js&"
import style0 from "./SkillsWorkflowSelector.vue?vue&type=style&index=0&id=047a22a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047a22a4",
  null
  
)

export default component.exports